import { render, staticRenderFns } from "./dashlet-card.vue?vue&type=template&id=07e195f4"
import script from "./dashlet-card.vue?vue&type=script&lang=js"
export * from "./dashlet-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports